import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useTourStore } from '@eliadmin/core/src/stores/tours-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiSearch } from 'react-icons/fi';
import { MultiSelectAsync } from '../../ui/multi-select-async';
import { useTourOptions } from '../../../hooks/use-tour-options';

export const TourFilterTours = () => {
  const { filter, setFilter } = useTourStore();
  const { t } = useTranslations();

  const tourOptions = useTourOptions();

  const currentValue = filter.tour
    ? {
        value: filter.tour.toString(),
        label: filter.tourName,
      }
    : null;

  return (
    <MultiSelectAsync
      {...tourOptions}
      isMulti={false}
      placeholder={t('text1836')}
      aria-label={t('text1836')}
      value={currentValue}
      onChange={selectedOption => {
        setFilter({ tourName: selectedOption ? selectedOption.label : '' });
        setFilter({ tour: selectedOption ? selectedOption.value : undefined });
      }}
      noOptionsMessage={() => t('text477')}
      isSearchable={true}
      menuPlacement="bottom"
      stylesConfig={{}}
      classNamesConfig={{
        container: () => cn('border-none'),
        valueContainer: () =>
          cn('cursor-pointer pl-1 rounded-lg bg-white text-sm font-medium border-none'),
        placeholder: () => cn('text-muted-foreground text-sm font-medium'),
        control: () => cn('rounded-lg h-full !min-h-[72px] bg-white'),
        menu: () => cn('rounded-lg !z-[100000] hide-scroll-bar'),
        menuList: () =>
          cn(
            '!left-[-40px] !top-2 border border-border !z-[10000] !bg-white block shadow-md hide-scroll-bar',
          ),
        indicatorsContainer: () => cn('!hidden'),
      }}
      className={cn(
        'relative flex w-full text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground',
        'focus-within:border-primary-foreground hover:cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
        'min-h-[48px] w-full rounded-lg border border-input bg-background text-sm transition-colors',
        'hover:cursor-pointer disabled:cursor-not-allowed disabled:opacity-50',
        'border-box items-center border-none',
      )}
      before={<FiSearch className="ml-4 h-6 w-6 cursor-default text-primary" />}
      variant={'outlined'}
    />
  );
};
